<template>
<div>
    <v-card outlined v-if="loaded">
        <v-card-text>
            <v-row>
                <v-col cols="12" sm="6" md="8">
                    <div class="headline font-weight-light">
                        All courses
                    </div>
                </v-col>

                <v-col cols="12" sm="6" md="4">
                    <div class="text-right">
                        <v-btn depressed class="accent" @click="$router.push('/admin-videos/add')">New course</v-btn>
                    </div>
                </v-col>
            </v-row>
        </v-card-text>

        <v-data-table
            :headers="headers"
            :items="filteredList"
            :items-per-page="25"
            no-data-text="No videos registered.">
            <template v-slot:item.videoslength="{ item }">
                {{item.videos.length}}
            </template>
            <template v-slot:item.action="{ item }">
                <v-icon small color="light-blue" class="mr-6" @click="$router.push('/video-section/'+item.id)">fa-link</v-icon>
            </template>
        </v-data-table>
    </v-card>

    <SendingLoader v-else/>
</div>
</template>

<script>
import _ from 'lodash'
import Helpers from '@/services/helpers'
import Videos from '@/firebase/videos'

export default {
    data: () => ({
        loaded: false,
        items: [],
        headers: [
            {
                text: 'Title',
                align: 'left',
                value: 'title',
            },
            {   text: 'Category', 
                value: 'categoryTitle' 
            },
            {   text: 'Videos', 
                value: 'videoslength' 
            },
            { 
                text: 'Actions', 
                align: 'right',
                value: 'action' 
            }
        ],
        search: '',
        categories: []
    }),
    mounted() {
        this.init();
    },
    watch: {
        tab() {
            if (this.tab == 0) {
                this.init();
            }
        }
    },
    computed: {
        filteredList() {
            if (this.loaded)
                return  this.items.filter(item => {
                        return item.title.toLowerCase().includes(this.search.toLowerCase());
                    });
        }
    },
    methods: {
        init() {
            Videos.getCourses()
                    .then(response => {
                        if (response.status === true) {
                            this.items = Helpers.formatItems(response.query);
                            this.getCoursesCategories();
                        } else {
                            this.$store.dispatch('setSnack', {kind:'error', text:'An error ocurred. Please try later.'});
                        }
                    });
        },
        getCoursesCategories() {
            Videos.getCoursesCategories()
                    .then(response => {
                        if (response.status === true) {
                            this.categories = Helpers.formatItems(response.query);
                            this.setNameCategories();
                            this.loaded = true;
                        } else {
                            this.$store.dispatch('setSnack', {kind:'error', text:'An error ocurred. Please try later.'});
                        }
                    });
        },
        setNameCategories() {
            this.items.forEach(dt => {
                dt.categoryTitle = this.categories.find(it => {return it.id == dt.category}).title;
            });
        }
    }
}
</script>